<iframe class="game-frame" [src]="gameSource" frameBorder="0"></iframe>
<div class="back-button" (click)="back.emit()">
  <div class="back-button-bg"><span class="icon icon-back"></span></div>
</div>
